export const INVOICING = [
  'Até 15 mil',
  'Até 50 mil',
  'Até 100 mil',
  'Acima de 100 mil',
]
